module.exports = __webpack_public_path__ + "files/fd04ddb44a9bbbf7552bb7ff25c993d0.png";